import React, { useEffect } from 'react';
import Alert from './alert';
import { useRouter } from 'next/router';
import useAlertProvider from './useAlertProvider';
import styles from './alert.module.scss';

const PageAlerts = () => {
  const router = useRouter();
  const { alerts, setAlerts } = useAlertProvider();

  useEffect(() => {
    if (router.asPath && alerts?.length === 0) {
      setAlerts([]);
    }
  }, [router.asPath, setAlerts]);

  return (
    <div className={styles.alertsContainer}>
      {alerts.map((alert, i) => (
        <Alert
          key={i}
          title={alert.title}
          footerContent={alert.actions}
          error={alert.error}
          info={alert.info}
        >
          {alert.message}
        </Alert>
      ))}
    </div>
  );
};

export default PageAlerts;
